import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    const headers = {responseType: "arraybuffer"}

    return {
        relatorioAtendimento(queryParms) {
            return repository.get(`${baseUrl}/erpsaude-relatorio-atendimento?${urlUtil.serialize(queryParms)}`, headers)
        },
    }
}